/* ============================================================
   Predictive search overlay.
   Opens from the header search box; live results from Shopify's
   /search/suggest.json (products, collections, pages). Keyboard
   nav (↑↓/Enter/Esc), focus trap, ~150ms debounce, mobile full-screen.
   Pricing is transition-safe (matches price-per-m2): <$10 ⇒ ×100.
   ============================================================ */
(function () {
  'use strict';

  function money(amount) {
    var n = parseFloat(amount) || 0;
    var perM2 = n < 10 ? n * 100 : n; // scaled (base÷100) vs already-real per-m²
    return '$' + perM2.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function highlight(text, q) {
    var safe = esc(text);
    if (!q) return safe;
    var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
    return safe.replace(re, '<mark class="hl">$1</mark>');
  }
  function debounce(fn, ms) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); };
  }

  function init() {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay || overlay.dataset.init) return;
    overlay.dataset.init = '1';

    var dialog = overlay.querySelector('[data-search-dialog]');
    var input = overlay.querySelector('[data-search-input]');
    var emptyEl = overlay.querySelector('[data-search-empty]');
    var resultsEl = overlay.querySelector('[data-search-results]');
    var seeAll = overlay.querySelector('[data-search-seeall]');
    var searchUrl = (seeAll && seeAll.getAttribute('href')) || '/search';
    var activeIndex = -1;
    var lastFocus = null;

    function rows() {
      var container = resultsEl.hidden ? emptyEl : resultsEl;
      return Array.prototype.slice.call(container.querySelectorAll('[data-row]'));
    }
    function setActive(i) {
      var rs = rows();
      rs.forEach(function (r) { r.classList.remove('is-active'); r.setAttribute('aria-selected', 'false'); });
      activeIndex = i;
      if (i >= 0 && rs[i]) { rs[i].classList.add('is-active'); rs[i].setAttribute('aria-selected', 'true'); rs[i].scrollIntoView({ block: 'nearest' }); }
    }

    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      showEmpty();
      setTimeout(function () { input.focus(); }, 40);
    }
    function close() {
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
      input.value = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function showEmpty() {
      emptyEl.hidden = false;
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
      seeAll.textContent = seeAll.dataset.default || seeAll.textContent;
      setActive(-1);
    }

    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var collections = r.collections || [];
      var pages = r.pages || [];
      var html = '';

      if (collections.length || pages.length) {
        html += '<div class="grouphead"><h5>Collections &amp; guides</h5></div>';
        collections.forEach(function (c) {
          html += '<a class="linkrow" data-row href="' + esc(c.url) + '"><span class="ico">COL</span>' + highlight(c.title, q) + '<span class="meta">Collection</span></a>';
        });
        pages.forEach(function (p) {
          html += '<a class="linkrow" data-row href="' + esc(p.url) + '"><span class="ico">DOC</span>' + highlight(p.title, q) + '<span class="meta">Guide</span></a>';
        });
      }

      html += '<div class="grouphead"><h5>Murals' + (products.length ? ' (' + products.length + ')' : '') + '</h5></div>';
      if (products.length) {
        products.forEach(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var thumb = img ? '<img src="' + esc(img) + '&width=108" alt="" width="54" height="54" loading="lazy">' : '<span class="th-ph"></span>';
          var sub = esc(p.type || p.vendor || '');
          html += '<a class="resrow" data-row href="' + esc(p.url) + '">' +
            '<span class="th">' + thumb + '</span>' +
            '<span class="info"><b>' + highlight(p.title, q) + '</b><span>' + sub + '</span></span>' +
            '<span class="pr">from ' + money(p.price_min || p.price) + '<small>/m²</small></span></a>';
        });
      } else {
        html += '<div class="search-empty-msg">No murals match “<b>' + esc(q) + '</b>” yet. Try a colour, room or style — or browse all.</div>';
      }

      resultsEl.innerHTML = html;
      emptyEl.hidden = true;
      resultsEl.hidden = false;
      seeAll.textContent = 'See all results for “' + q + '” →';
      seeAll.setAttribute('href', searchUrl + '?q=' + encodeURIComponent(q));
      setActive(-1);
    }

    var doSearch = debounce(function (q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) { render(data, q); })
        .catch(function () { /* network: leave prior state */ });
    }, 150);

    // ---- events ----
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-search-open]');
      if (trigger) { e.preventDefault(); open(); }
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
      if (e.target.closest('[data-search-close]')) close();
      var pill = e.target.closest('[data-search-term]');
      if (pill) { e.preventDefault(); input.value = pill.getAttribute('data-search-term'); input.focus(); doSearch(input.value); }
    });
    if (seeAll) seeAll.dataset.default = seeAll.textContent;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (!q) { showEmpty(); return; }
      doSearch(q);
    });

    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      var rs = rows();
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(activeIndex + 1, rs.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(activeIndex - 1, 0)); }
      else if (e.key === 'Enter') {
        if (activeIndex >= 0 && rs[activeIndex]) { window.location.href = rs[activeIndex].getAttribute('href'); }
        else if (input.value.trim()) { window.location.href = searchUrl + '?q=' + encodeURIComponent(input.value.trim()); }
      } else if (e.key === 'Tab') {
        // focus trap within the dialog
        var f = dialog.querySelectorAll('input, button, a[href]');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // tag server-rendered trending rows so ↑↓ works in the empty state too
    emptyEl.querySelectorAll('a.resrow').forEach(function (a) { a.setAttribute('data-row', ''); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
